import { Component, OnInit } from '@angular/core';
import { CoreUiPartialState, getUserName, getUserId } from '@pos-app/core-ui';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ManageusersInternalComponent } from '../manageusers-internal/manageusers-internal.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-manageusers-profile',
    templateUrl: './manageusers-profile.component.html',
    styleUrls: ['./manageusers-profile.component.scss'],
    imports: [ManageusersInternalComponent, AsyncPipe]
})
export class ManageusersProfileComponent implements OnInit {
  userId$: Observable<string>;

  constructor(private store: Store<CoreUiPartialState>) {}

  ngOnInit() {
    this.userId$ = this.store.pipe(select(getUserId));
  }
}

